// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const UserOut = zod.object({
  "auth_source": zod.enum(['local', 'entra']),
  "created_at": zod.iso.datetime({"offset":true}),
  "display_name": zod.string(),
  "email": zod.string(),
  "entra_linked": zod.boolean(),
  "id": zod.uuid(),
  "is_active": zod.boolean(),
  "last_login_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "roles": zod.array(zod.enum(['user', 'access_manager', 'monitor', 'asset_manager', 'industry_manager', 'admin'])),
  "upn": zod.union([zod.string(),zod.null()])
});

export type UserOut = zod.input<typeof UserOut>;
export type UserOutOutput = zod.output<typeof UserOut>;
